<template>
  <div
    class="custom-status-msg"
    :class="{ 'custom-status-msg--show': visible }"
  >
    <div class="custom-status-msg-modal"></div>
    <div class="status-msg-container">
      <div class="header">
        <div class="title">{{ title }}</div>
        <i class="icon icon-close" @click="close('cancel')"></i>
      </div>
      <div class="text-content">
        <div class="icon-status" :class="statusClass">
          <i class="icon" :class="iconClass"></i>
        </div>
        <div class="msg-content">
          <div class="sub-title">{{ subTitle }}</div>
          <div class="msg-detail">{{ message }}</div>
        </div>
      </div>
      <div class="status-msg-footer">
        <el-button size="mini" @click="close('cancel')">{{
          cancelBtnText
        }}</el-button>
        <el-button size="mini" type="primary" @click="close('confirm')">{{
          confirmBtnText
        }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      type: ''
    };
  },
  computed: {
    statusClass() {
      return `icon-status--${this.type}`;
    },
    iconClass() {
      return this.type === 'pass' ? 'icon-yanzhengtongguo' : 'icon-tishi';
    }
  },
  methods: {
    show() {
      this.visible = true;
      if (this.autoHidden) {
        setTimeout(() => {
          this.close('cancel');
        }, this.delay);
      }
    },
    close(type = 'cancel') {
      this.visible = false;
      this.$emit('close', type);
    }
  }
};
</script>

<style lang="scss">
.custom-status-msg {
  &--show {
    .custom-status-msg-modal {
      opacity: 0.5 !important;
    }
    .status-msg-container {
      opacity: 1 !important;
      top: 50% !important;
    }
  }
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9999;
  .custom-status-msg-modal {
    transition: all 0.3s;
    background: #000000;
    opacity: 0;
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .status-msg-container {
    transition: all 0.3s;
    background: #fff;
    position: relative;
    z-index: 10;
    top: 40%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 460px;
    opacity: 0;

    .header {
      height: 50px;
      padding: 0 18px;

      .title {
        color: #495057;
        font-weight: bold;
        font-size: 14px;
        float: left;
        line-height: 50px;
      }

      .icon {
        font-size: 14px;
        float: right;
        line-height: 14px;
        margin-top: 19px;
        &:hover {
          cursor: pointer;
        }
      }
    }

    .text-content {
      min-height: 170px;
      overflow: hidden;
      border-top: 1px solid #e9ebec;
      border-bottom: 1px solid #e9ebec;

      .icon-status {
        float: left;
        margin-left: 63px;
        margin-top: 63px;
        width: 35px;
        height: 35px;
        margin-right: 22px;
        .icon {
          font-size: 33px;
        }

        &--pass {
          color: #16d071;
        }

        &--error {
          color: #ff5c5b;
        }

        &--warning {
          color: #f9c851;
        }
      }

      .msg-content {
        width: 280px;
        margin-top: 60px;
        float: left;

        .sub-title {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          color: #495057;
          font-size: 16px;
          line-height: 24px;
          font-weight: bold;
        }

        .msg-detail {
          color: #6c757d;
          font-size: 12px;
          line-height: 16px;
          margin-top: 8px;
          word-break: break-all;
        }
      }
    }
  }

  .status-msg-footer {
    padding: 11px 16px;
    text-align: right;
    .el-button {
      min-width: 54px;
    }
  }
}
</style>
